<template>
  <div>
    <div class="canvas-top"></div>
    <div class="d-flex lighter-bg justify-content-center canvas-wrapper">
      <div v-bind:class="{ 'd-none': this.currentPage != 1 }">
        <canvas id="fabric-canvas"></canvas>
        <div class="vertical-line"></div>
      </div>
      <img
        id="exported-png"
        v-bind:style="{ maxHeight: this.zoomedCanvasHeight + 'px' }"
        class="img-fluid"
        v-bind:class="{
          'd-none': !(this.currentPage == 2 || this.currentPage == 4 || this.currentPage == 3),
        }"
      />
    </div>

    <b-modal id="modal-text" title="Mein Text">
      <div class="modal-inner-content">
        <div class="modal-title">Mein Text</div>

        <mdbInput
          id="lighterText"
          type="textarea"
          name="lighter_text"
          v-model="textToAdd"
          :style="fontStyles(selectedFont.value.family, selectedFont.value.weight)"
          class="mt-0"
          placeholder="Dein Text"
          required
        ></mdbInput>

        <ItemizerFontPicker :fonts="fonts" @input="setSelectedFont($event)" />
      </div>

      <template v-slot:modal-header="{}">
          <ModalHead></ModalHead>
      </template>

      <template v-slot:modal-footer="{}">
        <b-row class="justify-content-center w-100">
          <b-col cols="auto">
            <b-button variant="secondary" @click="submitModal('modal-text')"
              >Fertig</b-button
            >
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <b-modal id="modal-icons" title="Meine Icons">
      <div class="modal-title">Mein Icon wählen</div>
      <IconPicker :event="this.event" v-on:svg="svgSelected"></IconPicker>
      <template v-slot:modal-header="{}">
          <ModalHead></ModalHead>
      </template>
      <template v-slot:modal-footer="{ ok }">
        <b-row class="justify-content-center w-100">
          <b-col cols="auto">
            <b-button variant="secondary" @click="ok()">Fertig</b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { fabric } from "fabric";
import FontFaceObserver from "fontfaceobserver";
import IconPicker from "./IconPicker.vue";
import ItemizerFontPicker from "./ItemizerFontPicker.vue";
import { mdbInput } from "mdbvue";
import ModalHead from './ModalHead.vue';

const fillColor = '#939393';

export default {
  name: "ItemizerCanvas",
  components: {
    IconPicker,
    ItemizerFontPicker,
    mdbInput,
    ModalHead
  },
  props: {
    event: String,
    currentPage: Number,
  },
  data: function () {
    return {
      canvas: null,
      fonts: [
        { text: "WINSTON THIN", value: { family: "Winston", weight: "normal" } },
        { text: "WINSTON BOLD", value: { family: "Winston", weight: "bold" } },
      ],
      selectedFont: {
        value: { family: "Winston", weight: "normal" }
      },
      textToAdd: "",
      canvasW: 280,
      canvasH: 274,
      zoomFactor: 0.8,
    };
  },
  computed: {
    zoomedCanvasWidth: function () {
      return Math.round(this.canvasW * this.zoomFactor);
    },
    zoomedCanvasHeight: function () {
      return Math.round(this.canvasH * this.zoomFactor);
    },
  },
  mounted: function () {
    this.canvas = new fabric.Canvas("fabric-canvas");
    this.canvas.setHeight(this.zoomedCanvasHeight);
    this.canvas.setWidth(this.zoomedCanvasWidth);

    // Shape canvas according to the lighter SVG
    // this.shapeCanvas();

    // var text = new fabric.Text("", { left: 10, top: 200 });
    // this.canvas.add(text);

    // Set global fabric settings
    this.initFabricGlobal();

    // TODO: As soon as the printlayouts are returned by the API they need to be rendered here!
    // TODO 3 -> See Readme.md

    // Set default font
    this.selectedFont = this.fonts[0];
  },
  methods: {
    fontStyles(family, weight) {
      return `font-family: ${family}; font-weight: ${weight};`;
    },
    setSelectedFont($event) {
      this.selectedFont = $event;
    },
    svgSelected(svg) {
      // renders the selected SVG onto the canvas
      fabric.loadSVGFromURL(svg, (objects, options) => {
        // const color = '#ffffff';
        const obj = fabric.util.groupSVGElements(objects, options);
        obj.set({fill: fillColor})
        this.canvas.add(obj).renderAll();
        // obj.set({fill: '#00ff00'})
        obj.center();
      });
      // Hide modal
      this.$bvModal.hide("modal-icons");
    },
    exportToPng() {
      // TODO: Later do not export it to the img element.
      // The generated PNG need to be exported to the API later.
      // TODO 2 -> See Readme.md
      const dataURL = this.canvas.toDataURL({
        width: this.zoomedCanvasWidth,
        height: this.zoomedCanvasHeight,
        left: 0,
        top: 0,
        format: "png",
      });
      const img = document.getElementById("exported-png");
      img.src = dataURL;
    },
    // Initialize global fabric settings
    initFabricGlobal() {
      // Settings global corner style
      fabric.Object.prototype.transparentCorners = false;
      fabric.Object.prototype.cornerColor = "#b2b2b2";
      fabric.Object.prototype.cornerStyle = "circle";
      this.canvas.on("object:selected", (e) => {
        this.addDeleteBtn(e.target.oCoords.tr.x, e.target.oCoords.tr.y);
      });
      this.canvas.on("selection:cleared", () => {
        this.clearDeleteBtns();
      });
      this.canvas.on("object:deselected", () => {
        this.clearDeleteBtns();
      });
      this.canvas.on("object:modified", (e) => {
        this.addDeleteBtn(e.target.oCoords.tr.x, e.target.oCoords.tr.y);
      });
      this.canvas.on("object:scaling", () => {
        this.clearDeleteBtns();
      });
      this.canvas.on("object:moving", () => {
        this.clearDeleteBtns();
      });
      this.canvas.on("object:rotating", () => {
        this.clearDeleteBtns();
      });
    },
    deleteCanvasObject(eventData, target) {
      const canvas = target.canvas;
      canvas.remove(target);
      canvas.requestRenderAll();
    },
    addDeleteBtn(x, y) {
      this.clearDeleteBtns();
      var btnLeft = x - 10;
      var btnTop = y - 10;
      const img = document.createElement("img");
      img.src = `${this.$apiBaseUrl}/sites/default/files/graphics/close_icon_0.svg`;
      img.style.top = btnTop + "px";
      img.style.left = btnLeft + "px";
      img.style.height = 20 + "px";
      img.style.width = 20 + "px";
      img.style.position = "absolute";
      img.style.cursor = "pointer";
      img.classList.add("deleteBtn");
      img.classList.add("close-button");
      img.addEventListener("click", () => {
        this.runDeletion();
      });
      document.getElementsByClassName("canvas-container")[0].append(img);
    },
    clearDeleteBtns() {
      const elements = document.getElementsByClassName("deleteBtn");
      for (let elm of elements) elm.remove();
    },
    runDeletion() {
      const activeObjects = this.canvas.getActiveObject();
      this.canvas.remove(activeObjects);
    },
    submitModal(modalId) {
      let font = new FontFaceObserver(this.selectedFont.value.family);
      let self = this;
      font
        .load()
        .then(function () {
          self.addTextToCanvas();
          self.$bvModal.hide(modalId);
        })
        .catch(function () {
          self.addTextToCanvas();
          self.$bvModal.hide(modalId);
        });
    },
    addTextToCanvas() {
      let text = new fabric.Text(this.textToAdd, {
        left: 50,
        top: 150,
        fontFamily: this.selectedFont.value.family,
        fontWeight: this.selectedFont.value.weight,
        fontSize: 30,
      });
      text.set({fill: fillColor})
      this.canvas.add(text);
      this.textToAdd = "";
    },
    getImageDataUrl() {
      const dataURL = this.canvas.toDataURL({
        width: this.canvas.width,
        height: this.canvas.height,
        left: 0,
        top: 0,
        format: "png",
      });
      return dataURL;
    },
    getBlobFromCanvas(color) {
      let self = this;
      var p = new Promise(function (resolve, reject) {
        if (color) {
          for (let i = 0; i < self.canvas.getObjects().length; i++) {
            self.canvas.getObjects()[i].set({fill: color});
          }
        }
        if (!self.canvas.getElement()) {
          reject("promise error: canvas.getElement() failed");
        }
        // self.removeBackgroundFromCanvas();
        self.disableActiveObjects();
        self.zoomCanvas(2);
        self.canvas.getElement().toBlob(function (blob) {
          resolve(blob);
        });
      });
      return p;
    },
    removeBackgroundFromCanvas() {
      this.canvas.backgroundImage = false;
      this.canvas.renderAll();
    },
    shapeCanvas() {
      // Create clipping path
      let path = new fabric.Path(
        "M200.435 144.535C200.435 159.146 200.622 173.85 200.622 188.555L200.903 380.086C200.903 391.138 200.903 402.19 200.997 413.241C201.091 422.139 198.094 430.662 192.568 437.593C186.012 446.022 177.208 450.892 166.718 452.672C164.751 453.046 162.878 453.14 160.911 453.14L47.7716 453.421C28.2907 453.702 11.4321 439.934 7.77946 420.734C7.31117 418.205 7.12385 415.677 7.21751 413.054C7.12385 364.633 6.93653 316.118 6.84287 267.696C6.84287 242.783 6.74922 217.87 6.65556 192.957C6.46824 148.094 6.37458 103.138 5.99995 58.2756C5.90629 50.0337 13.5863 46.1937 19.7678 46.1C24.7317 46.1 29.7892 46.1937 34.8468 46.1937C39.5297 46.1937 80.2712 46.1 85.0477 46.1C84.4858 52.2815 85.6097 128.145 85.0477 134.607H146.956C161.286 134.607 175.709 134.701 190.039 134.42C196.501 134.233 200.435 138.635 200.435 144.535Z"
      );
      path.set({ left: 7, bottom: 0 });
      // Apply clipping path to the canvas
      this.canvas.clipPath = path;
    },
    zoomCanvas(scaleFactor) {
      // Set new canvas width and height
      this.canvas.setWidth(
        (this.canvas.getWidth() / this.zoomFactor) * scaleFactor
      );
      this.canvas.setHeight(
        (this.canvas.getHeight() / this.zoomFactor) * scaleFactor
      );
      let objects = this.canvas.getObjects();
      for (var i in objects) {
        objects[i].scaleX = (objects[i].scaleX / this.zoomFactor) * scaleFactor;
        objects[i].scaleY = (objects[i].scaleY / this.zoomFactor) * scaleFactor;
        objects[i].left = (objects[i].left / this.zoomFactor) * scaleFactor;
        objects[i].top = (objects[i].top / this.zoomFactor) * scaleFactor;
        objects[i].setCoords();
      }
      this.canvas.renderAll();
    },
    disableActiveObjects() {
      this.canvas.discardActiveObject();
    },
    resetCanvas() {
      this.canvas.clear();
    },
  },
};
</script>
<style lang="scss" scoped>
.lighter-bg {
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
h2 {
  font-size: 30px;
}
.canvas-top {
  height: 236px;
  background-image: url('~@/assets/imgs/top.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  margin-left: 109px;
}
.vertical-line {
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  border-left: dashed 2px #939393;
  transform: translateX(-50%);
}
.modal-title {
  font-size: 23px;
  margin-bottom: 20px;
}
</style>
